export const confirmUserBeforeTrigger = async ({ currentValue, shouldTrigger, refresh }) => {
  const hasTrigger = shouldTrigger(currentValue);

  if (!hasTrigger) {
    return {
      value: currentValue,
      shouldTrigger: false,
      refreshed: false,
    };
  }

  const refreshedValue = await refresh();

  return {
    value: refreshedValue,
    shouldTrigger: shouldTrigger(refreshedValue),
    refreshed: true,
  };
};
